import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

type NavItem = {
  to: string;
  label: string;
  icon: string;
  match: (pathname: string) => boolean;
};

const items: NavItem[] = [
  {
    to: "/landing",
    label: "Home",
    icon: "⌂",
    match: (p) => p === "/landing" || p === "/",
  },
  {
    to: "/scenes?lang=es",
    label: "Scenes",
    icon: "▦",
    match: (p) => p.startsWith("/scenes") || p.startsWith("/lesson"),
  },
];

export default function BottomNav() {
  const location = useLocation();
  const { user } = useAuth();
  if (!user) return null;

  const allItems = [...items];
  if (user.isAdmin) {
    allItems.push({
      to: "/admin",
      label: "Admin",
      icon: "⚙",
      match: (p) => p.startsWith("/admin"),
    });
  }

  return (
    <nav className="bottom-nav" aria-label="Primary">
      {allItems.map((item) => {
        const active = item.match(location.pathname);
        return (
          <Link
            key={item.to}
            to={item.to}
            className={`bottom-nav-item${active ? " is-active" : ""}`}
          >
            <span className="bottom-nav-item-icon" aria-hidden="true">
              {item.icon}
            </span>
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
